import React from 'react';
import TimesNIE2025 from 'views/TimesNIE2025';


const TheNPSFamilyPage = () => {
  return <TimesNIE2025/>;
};

export default TheNPSFamilyPage;